import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'

import { SectionState } from '../models/detail-page.model'

@Component({
    selector: 'app-detail-section',
    standalone: true,
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './detail-section.component.html',
    styleUrls: ['./detail-section.component.scss']
})
export class DetailSectionComponent {
    @Input() title?: string
    @Input() description?: string
    @Input() iconClass?: string
    @Input() collapsible = false
    @Input() collapsed = false
    @Input() state: SectionState = 'ready'
    @Input() emptyMessage = 'Nothing to show yet.'
    @Input() errorMessage = 'Something went wrong loading this section.'
    @Input() testId?: string
    /** Hide the section header bar entirely (used by KPI rows that are visually self-contained). */
    @Input() bare = false
    @Output() collapsedChange = new EventEmitter<boolean>()

    onToggle(): void {
        if (!this.collapsible) return
        this.collapsed = !this.collapsed
        this.collapsedChange.emit(this.collapsed)
    }
}
